import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import StatisticsByDayContentComponent from './StatisticsByDayContent/StatisticsByDayContent.container';
import { withRouter } from '../../RouterCompatibility.js';

const StatisticsByDayPage = ({ t, location }) => {
    const staticNames = (t && t.reportPage) || {};

    return (
        <div className="dashboard dashboard_consolidated-report">
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.titleByDay}</h2>
                </div>
            </div>

            <StatisticsByDayContentComponent
                location={location}
            />
        </div>
    );
};

StatisticsByDayPage.propTypes = {
    t: PropTypes.object,
    location: PropTypes.object
};

export default withRouter(withTranslation(StatisticsByDayPage));